<template>
  <div class="agent-traderole-edit">
    <div class="section" style="min-height: 100%">
      <div class="section-title">{{ $t("proxy.text229") }}</div>
      <div class="section-content mt-20">
        <el-form :model="form" label-width="auto" style="max-width: 600px">
          <el-form-item
            :label="$t('proxy.text230') + '：'"
            prop="name"
            required
          >
            <el-input
              v-model="form.name"
              placeholder=""
              style="width: 200px"
              :validate-event="false"
            />
          </el-form-item>
          <el-form-item
            :label="$t('fundHistory.text9') + '：'"
            prop="status"
            required
          >
            <el-radio-group v-model="form.status">
              <el-radio :value="1">{{ $t("proxy.text47") }}</el-radio>
              <el-radio :value="0">{{ $t("proxy.text48") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            :label="$t('fundHistory.text48') + '：'"
            prop="rulesGroupLevel"
            required
          >
            <el-input
              v-model="form.rulesGroupLevelName"
              style="width: 200px"
              disabled
            />
          </el-form-item>
          <el-form-item
            :label="$t('proxy.text43') + '：'"
            prop="isTemplate"
            required
          >
            <el-radio-group v-model="form.isTemplate">
              <el-radio :value="1">{{ $t("proxy.text44") }}</el-radio>
              <el-radio :value="0">{{ $t("proxy.text45") }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>

      <div class="section-title">{{ $t("proxy.text228") }}</div>
      <div class="section-content mt-20">
        <el-button type="primary" @click="openTemplateDialog">{{
          $t("proxy.text235")
        }}</el-button>
        <div class="table-container">
          <el-table
            :data="feeList"
            header-row-class-name="data-header"
            header-cell-class-name="data-header-cell"
            style="width: 100%; margin-top: 20px"
            height="400px"
          >
            <el-table-column :label="$t('proxy.text87')" width="130">
              <template #default="scope">
                <span>{{ scope.row.symbol || "--" }}</span>
              </template>
            </el-table-column>

            <!-- 可支配佣金 -->
            <el-table-column
              prop="disposablePoints"
              :label="$t('proxy.text240')"
              width="120"
            >
              <template #default="scope">
                <span>{{ scope.row.disposablePoints }}</span>
              </template>
            </el-table-column>

            <!-- 剩余佣金 -->
            <el-table-column
              prop="subordinatePoints"
              :label="$t('proxy.text54')"
              width="120"
            >
              <template #default="scope">
                <span>{{ scope.row.subordinatePoints }}</span>
              </template>
            </el-table-column>

            <!-- 返点 -->
            <el-table-column :label="$t('proxy.text304')" width="120">
              <template #default="scope">
                <el-input
                  v-model="scope.row.commission"
                  @input="updateFeeListCalculations(scope.row)"
                />
              </template>
            </el-table-column>

            <!-- 返佣比例 -->
            <el-table-column
              prop="subordinateScale"
              :label="$t('proxy.text241')"
              width="100"
            >
              <template #default="scope">
                <span>{{ scope.row.subordinateScale }}%</span>
              </template>
            </el-table-column>

            <!-- 可支配手续费 -->
            <el-table-column
              prop="disposableTradeFee"
              :label="$t('proxy.text305')"
              width="120"
            >
              <template #default="scope">
                <span>{{ scope.row.disposableTradeFee ?? "0.00" }}</span>
              </template>
            </el-table-column>

            <!-- 剩余手续费:（计算方式：tradeFee - tradeFeeCommission）   -->
            <el-table-column
              prop="subordinateTradeFee"
              :label="$t('proxy.text306')"
              width="120"
            >
              <template #default="scope">
                <span>{{ scope.row.subordinateTradeFee ?? "0.00" }}</span>
              </template>
            </el-table-column>

            <!-- 手续费返佣（可编辑） -->
            <el-table-column :label="$t('proxy.text307')" width="120">
              <template #default="scope">
                <el-input
                  v-model="scope.row.tradeFeeCommission"
                  @input="updateFeeCommissionCalculations(scope.row)"
                />
              </template>
            </el-table-column>

            <!-- 手续费返佣比例 -->
            <el-table-column :label="$t('proxy.text308')" width="150">
              <template #default="scope">
                <span>{{ scope.row.tradeFeeScale }}%</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="form-footer">
        <el-button link type="primary" class="mr-16" @click="cancel">{{
          $t("proxy.text167")
        }}</el-button>
        <el-button type="primary" @click="saveRulesGroup">{{
          $t("myAccount.text118")
        }}</el-button>
      </div>
    </div>

    <!-- 规则组模板对话框 -->
    <el-dialog
      :title="$t('proxy.text279')"
      v-model="templateDialogVisible"
      width="500px"
    >
      <el-select
        v-model="selectedTemplate"
        :placeholder="$t('proxy.text242')"
        style="width: 100%"
      >
        <el-option
          v-for="template in templates"
          :key="template.rulesGroupID"
          :label="template.rulesGroupName"
          :value="template.rulesGroupID"
        />
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="templateDialogVisible = false">{{
          $t("proxy.text167")
        }}</el-button>
        <el-button type="primary" @click="applyTemplate">{{
          $t("signUp.text35")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import apiService from "@/api/request";
import { useI18n } from "vue-i18n";
import trade from "@/store/modules/trade";

const route = useRoute(); // 用于获取路由参数
const t = useI18n().t;
const form = reactive({
  name: "",
  status: 1, // 状态默认 1 为正常
  rulesGroupLevel: "", // 规则组等级
  rulesGroupLevelName: "", // 类型名称
  isTemplate: 0, // 默认是否模板为 0
  warnRate: undefined,
  closingRate: undefined,
  isFixeSpreads: 0, // 默认固定点差为 0
});
const feeList = ref([]); // 交易品种列表
const templates = ref([]); // 模板列表
const selectedTemplate = ref(null);
const templateDialogVisible = ref(false);

// 获取路由传递的groupName
onMounted(() => {
  const rulesGroupID = route.query.rulesGroupID; // 从路由参数中获取rulesGroupID

  if (rulesGroupID) {
    form.rulesGroupID = rulesGroupID; // 如果存在rulesGroupID，则设置到form中
  }

  fetchRulesGroupInfo();
});

// 请求上级规则组信息并初始化表单，传入路由参数中的rulesGroupID
const fetchRulesGroupInfo = async () => {
  const rulesGroupID = route.query.rulesGroupID || null; // 从路由参数中获取rulesGroupID
  const parentId = route.query.parentId || null; // 从路由参数中获取rulesGroupID

  try {
    // const params 如果rulesGroupName有值就意味着是编辑不是新增，传入rulesGroupID，否则就是新增，传入parentId
    const params = parentId ? { parentId } : { rulesGroupID };
    const { data } = await apiService.proxyRulesGroupInfo(params);
    Object.assign(form, data.model);

    const groupName = route.query.groupName || ""; // 获取上个页面传来的groupName参数
    // 如果上面没有传入groupName，则不需要设置rulesGroupID
    if (!groupName) {
      console.log("groupName is not passed");
      form.rulesGroupID = "";
      form.parentId = parentId;
      console.log("parentId:", parentId);
    } else {
      form.name = groupName;
      form.rulesGroupID = rulesGroupID;
      console.log("form.parentId:", form.parentId);
    }

    form.rulesGroupLevel = data.model.rulesGroupLevel;

    // 根据规则组等级显示类型名称
    switch (data.model.rulesGroupLevel) {
      case 1:
        form.rulesGroupLevelName = t("proxy.text225");
        break;
      case 2:
        form.rulesGroupLevelName = t("proxy.text226");
        break;
      case 3:
        form.rulesGroupLevelName = t("proxy.text227");
        break;
      default:
        form.rulesGroupLevelName = t("proxy.text227");
    }

    feeList.value = data.feeList.map((item) => {
      const disposablePoints = parseFloat(item.disposablePoints) || 0;
      const commission = parseFloat(item.commission) || 0;
      const subordinateScale =
        disposablePoints > 0
          ? parseFloat(((commission / disposablePoints) * 100).toFixed(2)) // 转为百分比并保留两位小数
          : "0.00";
      const disposableTradeFee = parseFloat(item.disposableTradeFee) || 0;
      const tradeFeeCommission = parseFloat(item.tradeFeeCommission) || 0;
      const subordinatePoints = Math.max(
        0,
        parseFloat((disposablePoints - commission).toFixed(2))
      );
      return {
        ...item,
        subordinatePoints: subordinatePoints, // 剩余佣金
        subordinateScale: subordinateScale, // 返佣比例
        subordinateTradeFee: (disposableTradeFee - tradeFeeCommission).toFixed(
          2
        ), // 剩余手续费
      };
    });

    console.log("feeList:", feeList.value);
  } catch (error) {
    console.log("获取规则组信息失败", error);
  }
};

// 保存规则组
const saveRulesGroup = async () => {
  // 校验form.name是否为空
  if (!form.name) {
    ElMessage.error(t("proxy.text177"));
    return;
  }

  try {
    const requestData = {
      rulesGroups: {
        rulesGroupID: form.rulesGroupID || 0,
        rulesGroupName: form.name,
        status: form.status ? 1 : 0,
        isTemplate: form.isTemplate ? 1 : 0,
        rulesGroupLevel: form.rulesGroupLevel, // 传递保存时的 rulesGroupLevel
        closingRate: form.closingRate || 0,
        warnRate: form.warnRate || 0,
        isFixeSpreads: form.isFixeSpreads ? 1 : 0,
        parentId: form.parentId || null,
        mt4group: form.mt4group || "",
        mt4demogroup: form.mt4demogroup || "",
        minintogold: form.minintogold || 0.0,
        mt4warnRate: form.mt4warnRate || 0,
        allowSelect: form.allowSelect,
        leverage: form.leverage || 0,
      },
      rulesContractFees: feeList.value.map((fee) => ({
        ...fee, // 保留所有字段
        symbol: fee.symbol || "",
        disposablePoints: parseFloat(fee.disposablePoints) || 0, // 可支配佣金
        commission: parseFloat(fee.commission) || 0, // 返佣
        subordinatePoints: fee.subordinatePoints || 0, // 剩余佣金
        subordinateScale: fee.subordinateScale || 0, // 返佣比例
        disposableTradeFee: parseFloat(fee.disposableTradeFee) || 0, // 可支配手续费
        tradeFeeCommission: parseFloat(fee.tradeFeeCommission) || 0, // 手续费返佣
        tradeFeeScale: fee.tradeFeeScale || 0, // 手续费返佣比例
      })),
    };
    console.log("requestData:", requestData);

    const response = await apiService.proxySaveRulesGroup(requestData);
    if (response.status === 1) {
      ElMessage.success(t("proxy.text243"));
      // 返回上一页
      history.back();
    } else {
      ElMessage.error(response.message);
    }
  } catch (error) {
    ElMessage.error(t("proxy.text244"));
  }
};

// 监听 feeList 的变化，计算 subordinatePoints 和 subordinateScale
const updateFeeListCalculations = (row) => {
  const disposablePoints = parseFloat(row.disposablePoints) || 0; // 可支配佣金
  let commission = parseFloat(row.commission) || 0; // 当前输入的返佣

  // 判断返佣是否大于可支配佣金
  if (commission > disposablePoints) {
    ElMessage.error(t("proxy.text291"));
    commission = disposablePoints; // 重置为最大可支配佣金
    row.commission = commission; // 同步返佣值
  }

  // 计算剩余佣金和返佣比例
  row.subordinatePoints = parseFloat(
    (disposablePoints - commission).toFixed(2)
  ).toString(); // 修复浮点数问题并去掉尾随0
  row.subordinateScale =
    disposablePoints > 0
      ? parseFloat(((commission / disposablePoints) * 100).toFixed(2)) // 转为百分比并保留两位小数
      : 0;
};

// 监听 feeList 的变化，计算 tradeFeeCommission 和 tradeFeeScale
const updateFeeCommissionCalculations = (row) => {
  const disposableTradeFee = parseFloat(row.disposableTradeFee) || 0; // 可支配手续费
  let tradeFeeCommission = parseFloat(row.tradeFeeCommission) || 0; // 当前输入的返佣

  console.log("disposableTradeFee:", disposableTradeFee);
  console.log("subordinateTradeFee:", tradeFeeCommission);

  // 判断手续费返佣是否大于可支配手续费
  if (tradeFeeCommission > disposableTradeFee) {
    ElMessage.error(t("proxy.text303"));
    tradeFeeCommission = disposableTradeFee; // 重置为最大可支配手续费
    row.tradeFeeCommission = tradeFeeCommission; // 同步返佣值
  }

  // 计算剩余手续费和手续费返佣比例
  row.subordinateTradeFee = parseFloat(
    (disposableTradeFee - tradeFeeCommission).toFixed(2)
  ).toString(); // 修复浮点数问题并去掉尾随0
  row.tradeFeeScale =
    disposableTradeFee > 0
      ? parseFloat(((tradeFeeCommission / disposableTradeFee) * 100).toFixed(2)) // 转为百分比并保留两位小数
      : 0;
};

// 引入规则组模板
const openTemplateDialog = async () => {
  try {
    // 传入level
    const params = { level: form.rulesGroupLevel };
    const { data } = await apiService.proxyTemplateRulesGroupList(params);
    templates.value = data.list;
    templateDialogVisible.value = true;
  } catch (error) {
    // ElMessage.error('获取模板失败');
  }
};

// 应用选中的模板
const applyTemplate = async () => {
  try {
    const { data } = await apiService.proxyRulesGroupInfo({
      rulesGroupID: selectedTemplate.value,
    });
    feeList.value = data.feeList; // 覆盖当前的交易品种配置
    templateDialogVisible.value = false;
  } catch (error) {
    // ElMessage.error('应用模板失败');
  }
};

// 删除交易品种
// const removeFee = (index) => {
//   feeList.value.splice(index, 1);
// };

// 初始化获取规则组信息
// onMounted(fetchRulesGroupInfo);

// 取消操作
const cancel = () => {
  // 返回上一页
  history.back();
};
</script>

<style scoped lang="less">
.agent-traderole-edit {
  height: 99%;
}
.form-footer {
  margin-top: 40px;
}
.table-container {
  padding: 0;
  max-height: 400px;
  overflow-y: auto;
}
.dialog-footer {
  padding-top: 20px;
  display: flex;
  justify-content: right;
}
</style>